import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./ResidenceSlider.css";
import ListingCard from "./ListingCard";
import { Link } from "react-router-dom";
import axios from "axios";

function ResidenceSlider() {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          "https://estate.deltaservis.com.tr/items/list.json"
        );
        // response.data doğrudan JSON veriyi içerir
        const formattedProducts = response.data.map((item) => ({
          id: item.id,
          image: item.image,
          title: item.title,
          details: item.details,
          location: item.location,
          district: item.district,
        }));
        setProducts(formattedProducts);
      } catch (error) {
        console.error("Veri çekme hatası:", error);
      }
    };

    fetchProducts();
  }, []);
  return (
    <div className="container-xl residence-slider my-5">
      <h2 className="featured-title">Daire & Rezidans </h2>
      <p className="featured-description">
        Modern yaşamın tüm ihtiyaçlarına uygun, konforlu ve şık tasarımlı
        seçenekler sunuyoruz. Şehir hayatının merkezinde, güvenlik ve sosyal
        olanaklarla donatılmış yaşam alanlarımız, her detayıyla size özel bir
        deneyim vadediyor. Hayalinizdeki evi bulmak için şimdi keşfedin!{" "}
        <Link className="more-info" to="/projects/residence">
          Daha Fazla
        </Link>
      </p>
      <Slider {...settings}>
        {products
          .filter((product) => product.details.buldingType === "residence")
          .map((product) => (
            <ListingCard key={product.title} listing={product} />
          ))}
      </Slider>
    </div>
  );
}

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div className="arrow next" onClick={onClick}>
      ›
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="arrow prev" onClick={onClick}>
      ‹
    </div>
  );
}

export default ResidenceSlider;
